import { useMemo } from 'react';

import {
  UK_ETHNICITY_OPTIONS,
  US_ETHNICITY_OPTIONS,
} from '@lib/utils/constants/applicationConstants';
import { useJobsBoardFiltersViewContext } from '@views/jobsBoard/context';

import { FilterCollapse } from '../components/FilterCollapse';
import { useJobsBoardFiltersModalContext } from '../context';
import { StyledCheckboxGroup } from '../styles';

export const EthnicityFilter = () => {
  const { modalFilters, setEthnicities } = useJobsBoardFiltersModalContext();

  const { mainViewCountry } = useJobsBoardFiltersViewContext();
  const ethnicityOptions = useMemo(() => {
    if (mainViewCountry === 'UK') {
      return UK_ETHNICITY_OPTIONS;
    }
    return US_ETHNICITY_OPTIONS;
  }, [mainViewCountry]);

  const subtitle = useMemo(() => {
    if (!modalFilters?.ethnicities?.length) {
      return 'Any';
    }

    return (
      (ethnicityOptions as string[])
        .filter((ethnicity) => modalFilters?.ethnicities?.includes(ethnicity))
        .join(', ') || 'Any'
    );
  }, [modalFilters?.ethnicities, ethnicityOptions]);
  return (
    <FilterCollapse
      title={'Ethnicity'}
      subtitle={subtitle}
      content={
        <StyledCheckboxGroup
          value={modalFilters?.ethnicities ?? []}
          options={ethnicityOptions as unknown as string[]}
          onChange={(value) => {
            setEthnicities(value as string[]);
          }}
        />
      }
    />
  );
};
